<template>
  <div class="news-item">
    <div v-if="title">
      <div class="row">
        <router-link
          :to="{ name: 'NewsDetails', params: { newsId: id } }"
          style="text-decoration: none"
        >
          <!--           <span class="title"> {{ title }} </span>
 -->
          <div class="title"><span v-html="title"></span></div>
        </router-link>

        <div class="detail-item">
          <span class="detail-tag">Gepubliceerd op: </span>
          <span class="detail-value">{{ formatDate(date) }}</span>
        </div>
      </div>

      <div v-html="introduction" class="desc-short" v-if="introduction"></div>

      <div v-if="showMore && Body">
        <q-separator />
        <div v-html="Body" class="desc-body"></div>
      </div>

      <q-btn
        flat
        icon="expand_less"
        v-if="showMore"
        @click="toggleShowMore()"
      />
      <q-btn
        flat
        icon="expand_more"
        v-if="!showMore"
        @click="toggleShowMore()"
      />
    </div>
  </div>
</template>

<script>
import { ref, computed } from 'vue';
import moment from 'moment';
export default {
  props: {
    newsTitle: String,
    intro: String,
    id: String,
    newsItem: Object,
    body: String,
  },
  setup(props) {
    const title = computed(() => {return props.newsTitle});
    const introduction = computed(() => {return props.intro});
    
    const date =
      props.newsItem.date != null
        ? moment(props.newsItem.date).format('YYYY-MM-DD')
        : null;
    const Body = ref(props.body);

    const showMore = ref(false);

    const toggleShowMore = () => (showMore.value = !showMore.value);

    const formatDate = (stringDate) => {
      const dateN = new Date(stringDate);
      return moment(dateN).format('DD-MM-YYYY');
    };
    return {
      formatDate,
      title,
      introduction,
      showMore,
      toggleShowMore,
      date,
      Body,
    };
  },
};
</script>
